<script>
    import { onMount, createEventDispatcher, tick } from 'svelte';
    import Identity from 'svelte-key';
    import ImageViewer from 'iv-viewer';
    import { fade } from 'svelte/transition';
    import { fetchData, generateID, getLocalServer } from '../utils/Data.svelte';
    import { sortByName, ignoreCaseSort } from '../utils/Sort.svelte';
    import { shareAlt, bookmark, refresh, headset, videocam, document as documentIcon, arrowBack, download, informationCircleOutline } from 'ionicons/icons/index.mjs';

    export let modal;
    export let session;
    export let tooltips;
    let key = "0";
    let loading = true;
    let error = "";
    let renderer = null;
    let version = "0";
    let properties = {};
    let media = {};
    let selectedMedia = null;
    let edit = true;
    let type = "file";
    let name = "";
    let description = "";
    let group = "";
    let link = "";
    let image = "";
    let viewer = null;

    const dispatch = createEventDispatcher();
    function sendMessage(message) {
		dispatch('message', message);
    }
    onMount(async () => {
        var idField = modal.layer.metadata["geosync:id"];
        var id = modal.feature.properties[idField];
        var versionField =  modal.layer.metadata["geosync:version"];
        let [res, err]  = await fetchData(modal.history.uri);
		if (err) {
            console.log(err);
            return;
        }
        var version = "0";
        //if (versionField && res.properties[versionField])
            //version = res.properties[versionField];
        properties = res.properties;

        var path = ""
        /*if (versionField) {
            path = "/v1/media/layer/" + modal.layer.metadata["geosync:media"] + "/" + properties[idField] + "/" + properties[versionField];
        }
        else {*/
            path = "/v1/media/layer/" + modal.layer.metadata["geosync:media"] + "/" + properties[idField];
        //}
        
        [res, err]  = await fetchData(path, {
            headers: {
                'Authorization': 'Bearer ' + session.token
            }
        });
		if (err) {
            console.log(err);
            return;
        }
        media = res.data.media;
    });

    function load360() {
        pannellum.viewer('panorama', {
            panorama: selectedMedia.uri,
            autoLoad: true
        });
    }

    function loadImage() {
       image = selectedMedia.uri;
       const container = document.querySelector('#mb-preview');
        viewer = new ImageViewer(container, {});

        viewer.load(image);
    }

    async function saveHandler(event) {
        event.currentTarget.blur();
        loading = true;
        error = "";
        let data = new FormData();
        data.append("name", name);
        data.append("description", description);
        data.append("group", group);
        if (modal.media) {
            var filename = "";
            if (modal.media.type == "link") {
                filename = modal.media.name;
            }
            else {
                var url = new URL(modal.media.uri);
                filename =  decodeURIComponent(url.pathname.substring(url.pathname.lastIndexOf("/") + 1));
            }
            data.append("filename", filename);
            data.append("type", modal.media.type);
        }
        if (type === "link")
            data.append("link", link);
        else if (type === "download") {
            data.append("download", "1")
        }
        else {
            data.append("download", "0")
        }

        var isScene = true;
        var path = "/scene/" + modal.id;
        var version = "0";
        
        if (modal.feature && modal.layer) {
            if (modal.layer.source) {
                let parts = modal.layer.source.split("_");
                if (parts.length == 2 && modal.layer.metadata) {
                    /*if (modal.layer.metadata["geosync:version"] && modal.feature.properties[modal.layer.metadata["geosync:version"]]) {
                        version = modal.feature.properties[modal.layer.metadata["geosync:version"]];
                    }*/
                    path = "/layer/" + modal.layer.metadata["geosync:media"] + "/" + modal.feature.properties[modal.layer.metadata["geosync:id"]] + "/" + version;
                    isScene = false;
                }
            }
        }
        let [res, err]  = await fetchData("/v1/media" + path, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + session.token
            },
            body: data
        });
        loading = false;
		if (err) {
            var item = {
                id: generateID,
                name,
                description,
                group,
                filename,
                type
            }
            if (type === "link") {
                item.link = link;
                addPendingMedia(item);
            }
        }
        else {
            dispatch('message', {
                type: "media",
                data: {
                    isScene: isScene
                }
            });
        }
        dispatch('message', {
            type: "toast",
            data: {
                message: "Media saved."
            }
        });
        close();
    }

    async function shareHandler(event) {
        event.currentTarget.blur();
        var id = modal.feature.properties[modal.layer.metadata["geosync:id"]] + "";
        var media = modal.layer.metadata["geosync:media"];
        var version = modal.history.id;
        let [res, err]  = await fetchData("/v1/share/history", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + session.token
            },
            body: JSON.stringify({
				media: media,
				id: id,
                version: version
			})
        });
		if (err) {
			console.log(err);
			return;
		}
		if (res.status == "success") {
			var win = window.open(res.data.link, '_blank');
			win.focus();
		}
    }

    function back() {
        edit = false;
        selectedMedia = null;
        type = "file";
        name = "";
        description = "";
        group = "";
        link = "";
        key = generateID();
    }

	function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
    }
</script>

<div class="modal modal-lg active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">History</div>
                </div>
                <div class="tile-action">
                    {#if selectedMedia}
                        {#if edit}
                            <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Save" on:click={saveHandler} aria-label="Save"><i class="icon icon-check mt-1"></i></button>
                        {/if}
                        <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Back" on:click={back} aria-label="Back"><i class="icon icon-arrow-left mt-1"></i></button>
                    {:else}
                        <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Share" on:click={shareHandler} aria-label="Share"><i class="svg svg-light">{@html shareAlt.md}</i></button>
                        <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                    {/if}
                </div>
            </div>
        </div>
        <div class="modal-body">
            {#if selectedMedia}
                {#if edit}
                    <form class="content" on:submit|preventDefault={saveHandler} autocomplete="off">
                        <label class="form-label" for="type">Type</label>
                        <select class="form-select" id="type" bind:value={type}>
                            <option>file</option>
                            <option>link</option>
                        </select> 
                        <label class="form-label" for="name">Name</label>
                        <input class="form-input" bind:value={name} type="text" id="name">
                        <label class="form-label" for="description">Description</label>
                        <input class="form-input" bind:value={description} type="text" id="description">
                        <label class="form-label" for="group">Group</label>
                        <input class="form-input" bind:value={group} type="text" id="group">
                        {#if type == "link"}
                            <label class="form-label" for="link">Link</label>
                            <input class="form-input" bind:value={link} type="text" id="link">
                        {/if}
                        <input type="submit" style="position: absolute; left: -9999px"/>
                    </form>
                {:else}
                    {#if selectedMedia.type == "image"}
                        <div id="mb-preview" class="preview"></div>
                    {:else if selectedMedia.type == "360"}
                        <div id="panorama" class="threejs"></div>
                    {:else if selectedMedia.type == "pdf"}
                        <div id="mb-preview" class="preview">
                            <iframe class="iframe" title="media" frameBorder="0" src={selectedMedia.uri} />
                        </div>
                    {:else if selectedMedia.type == "document"}
                        <div id="mb-preview" class="preview">
                            <iframe class="iframe" title="media" frameBorder="0" src={"https://docs.google.com/viewer?url=" + encodeURIComponent(selectedMedia.uri) + "&embedded=true"} />
                        </div>
                    {:else if selectedMedia.type == "audio" || selectedMedia.type == "video"}
                        <div id="mb-preview" class="preview">
                            <iframe class="iframe" title="media" frameBorder="0" src={selectedMedia.uri} />
                        </div>
                    {:else}
                        <div id="mb-preview" class="preview text-center" style="padding-top:100px;">
                            <p class="empty-title h5">Preview not supported.</p>
                        </div>
                    {/if}
                {/if}
            {:else}
            <Identity key={key}>
                <div class="container">
                    <div class="columns col-gapless">
                        <div class="column col-6 col-sm-12">
                            <table class="table table-striped light"><tbody>
                                {#each Object.keys(properties) as key}
                                    <tr>
                                        <td>{ key }</td>
                                        <td>{ properties[key] }</td>
                                    </tr>
                                {/each}
                            </tbody></table>
                        </div>
                        <div class="column col-6 col-sm-12">
                            {#if Object.keys(media).length > 0}
                                {#each Object.keys(media).sort(ignoreCaseSort) as section}
                                    <div class="accordion" in:fade>
                                        <input type="checkbox" id={"group-" + section} name="accordion-checkbox" hidden>
                                        <label class="accordion-header" for={"group-" + section}>
                                            <div class="tile tile-centered">
                                                <div class="tile-icon">
                                                    <div class="example-tile-icon">
                                                    <i class="icon icon-arrow-right centered"></i>
                                                    </div>
                                                </div>
                                                <div class="tile-content">
                                                    <div class="tile-title">{section}</div>
                                                </div>
                                            </div>    
                                        </label>
                                        <div class="accordion-body">
                                            <ul class="menu menu-nav">
                                                {#if Object.values(media[section]).length > 0}
                                                    {#each Object.values(media[section]).sort(sortByName) as item}
                                                        <div class="tile tile-centered">
                                                            <div class="tile-icon">
                                                                <div class="type-icon">
                                                                    {#if item.type == "link"}
                                                                        <i class="svg">{@html link.md}</i>
                                                                    {:else if item.type == "download"}
                                                                        <i class="svg">{@html download.md}</i>
                                                                    {:else if item.type == "pdf" || item.type == "document"}
                                                                        <i class="svg">{@html bookmark.md}</i>
                                                                    {:else if item.type == "image"}
                                                                        <i class="svg">{@html image.md}</i>
                                                                    {:else if item.type == "360"}
                                                                        <i class="svg">{@html refresh.md}</i>
                                                                    {:else if item.type == "audio"}
                                                                        <i class="svg">{@html headset.md}</i>
                                                                    {:else if item.type == "video"}
                                                                        <i class="svg">{@html videocam.md}</i>
                                                                    {:else}
                                                                        <i class="svg">{@html document.md}</i>
                                                                    {/if}
                                                                </div>
                                                            </div>
                                                            <div class="tile-content">
                                                                <li class="menu-item">
                                                                    {#if item.type == "link" || item.type == "pdf"}
                                                                        <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                                                    {:else if item.type == "download"}
												                    	{#if window.platform == "Windows"}
                                                                            <button class="btn btn-link" on:click|stopPropagation={async (e) => {
                                                                                e.currentTarget.blur();
                                                                                let [res, err]  = await fetchData(getLocalServer() + "/core", {
                                                                                    method: "POST",
                                                                                    headers: {
                                                                                            'Accept': 'application/json',
                                                                                            'Content-Type': 'application/json'
                                                                                    },
                                                                                    body: JSON.stringify({
                                                                                        url: item.uri
                                                                                    })
                                                                                });
                                                                                if (err || !res.found) {
                                                                                        window.open(item.uri, "_blank");
                                                                                }
                                                                            }}>
                                                                            {item.name}
                                                                            </button>
                                                                        {:else}
                                                                            <a class="btn btn-link" target="_blank" href={item.uri}>{item.name}</a>
                                                                        {/if}
                                                                    {:else}
                                                                        <button class="btn btn-link"
                                                                        on:click|stopPropagation={async (e) => {
                                                                            e.currentTarget.blur();
                                                                            selectedMedia = item;
                                                                            await tick();
                                                                            if (selectedMedia) {
                                                                                if (selectedMedia.type == "image")
                                                                                    loadImage();
                                                                                else if (selectedMedia.type == "360")
                                                                                    load360();
                                                                            }
                                                                        }}>{item.name}</button>
                                                                    {/if}
                                                                </li>
                                                            </div>
                                                            <div class="tile-action">
                                                                <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Details" on:click|stopPropagation={(e) => {
                                                                            e.currentTarget.blur();
                                                                            edit = true;
                                                                            selectedMedia = item;
                                                                            type = selectedMedia.type;
                                                                            name = selectedMedia.name;
                                                                            description = selectedMedia.description;
                                                                            group = selectedMedia.group;
                                                                            link = selectedMedia.link;
                                                                        }}>
                                                                    <i class="svg">{@html informationCircleOutline.md}</i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    {/each}
                                                {/if}
                                            </ul>
                                        </div>
                                    </div>
                                {/each}
                            {/if}
                        </div>
                    </div>
                </div>
                </Identity>
            {/if}
        </div>
    </div>
</div>

<style>
    .container {
        padding: 0;
    }
    .preview {
        width: 100%;
        height: 100%;
    }
    .threejs {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .iframe {
        width: 100%;
        height: 100%;
    }
    .modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 0;
        height: calc(100vh - 2.1rem);
    }
	.accordion .accordion-header {
		cursor: pointer;
		user-select: none;
		height: 1rem;
		padding: 0.4rem;
	}
	.accordion-body {
		padding-left: 1rem;
        margin: 0.4rem 0 0 0;
    }
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
    }
    .menu {
        padding: 0;
    }
    .menu .menu-item {
        padding: 0;
    }
	.menu .menu-item > a, .menu .menu-item > button {
        border: 0;
        margin: 0;
        padding: 0.4rem 0.8rem;
        text-align: left;
	}
	.menu-item a:hover, .menu-item a:visited {
		background-color: transparent;
	}
	.menu .menu-item > a:focus, .menu .menu-item > a:hover {
		background-color: transparent;
	}
	#image-preview {
        overflow: hidden;
    }
    .content {
        margin-left: 1rem;
        margin-right: 1rem;
    }
	.type-icon {
		display: inline-block;
		font-size: 0.8rem;
		height: 1.8rem;
		width: 1.8rem;
		line-height: 1.2rem;
		outline: none;
		padding: 0.25rem 0.4rem;
		text-align: center;
    }
</style>